import React, { Component, Fragment } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Button,
  MenuItem,
  Tab,
  Tabs,
} from '@material-ui/core'

import { onChangeEditHOF } from '../../utils/common'

import MetrcEmployeeKey from './MetrcEmployeeKey'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import SearchField from '../common/SearchField'

const MetrcEmployeeKeyEditable = EditableHOCWrapper(MetrcEmployeeKey)

export default class MetrcEmployees extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = (data, afterOnSave) => {
    this.props.onUpdateEmployeeKey(data, afterOnSave)
  }

  render() {
    const {
      metrcEmployeeKeys = [],
      searchTerm = '',
      onSearchEmployeeKey,
      onChangeTerm,
    } = this.props
    return (
      <Fragment>
        <Grid container>
          <Grid className="list-container" item xs={12} sm={12} md={12} lg={12}>
            <SearchField
              onChange={onChangeTerm}
              value={searchTerm}
              onSearch={onSearchEmployeeKey}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Employee Name</TableCell>
                      <TableCell>Metrc API Key</TableCell>
                      <TableCell>Enabled</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metrcEmployeeKeys &&
                      metrcEmployeeKeys.map((row, index) => {
                        return (
                          <MetrcEmployeeKeyEditable
                            key={index}
                            lastModified={row.lastModified}
                            dataToEdit={row}
                            onSave={this.onSave}
                            onDelete={() => {
                              this.props.onDelete(row)
                            }}
                            defaultEditMode={false}
                          />
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Metrc/MetrcEmployees.js